import { isUndefined } from "lodash";
import { type WistiaVideoProps } from "./component";

export const getKey = (props: WistiaVideoProps): string =>
  `${props.allowFullScreen}-${props.autoPlay}-${props.isBackground}-${props.loop}-${props.mute}-${
    props.showControls
  }-${getVideoId(props)}`;

export const getOptions = (props: WistiaVideoProps): string => {
  const showControls = !props.isBackground && (props.showControls || isUndefined(props.showControls));

  return `autoPlay=${props.autoPlay ?? false} silentAutoPlay=${props.mute || props.isBackground} muted=${
    props.autoPlay ? 1 : props.mute || props.isBackground
  } settingsControl=${showControls} qualityControl=${showControls} fullscreenButton=${showControls} volumeControl=${showControls} playbar=${showControls} playlistLoop=${
    props.loop ?? false
  }`;
};

export const getVideoId = (props: WistiaVideoProps): string => {
  if (props.videoId) return props.videoId;

  const match = (props.url ?? "").match(/medias\/([^/]+)/);
  return match ? match[1] : "";
};

export const isWistiaURL = (url: string | null | undefined) => (url || "").includes("wistia.com");
